import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ChameleonService } from './chameleon.service';
import { Organization } from './data/organization';

@Injectable()
export class OrganizationService {
  orgs: Organization[];
  rootOrgs: Organization[];
  rootOrgId: number;

  constructor(
    private authService: AuthService,
    private chameleonService: ChameleonService
  ) {
    const keys = ['rootOrgId', 'orgs'];
    keys.forEach(s => {
      var v = localStorage.getItem(s);
      if (v) {
        switch (s) {
          case 'rootOrgId':
            this[s] = parseInt(v);
            break;
          default:
            try {
              this[s] = JSON.parse(v || null);
            } catch {
              localStorage.removeItem(s);
              this[s] = null;
            }
        }
      }
    });
    this.authService.didLogout$.subscribe(() => {
      keys.forEach(s => {
        this[s] = null;
        localStorage.removeItem(s);
      });
    });
  }

  addOrg(org: Organization) {
    this.orgs.push(org);
    this.setOrgs(this.orgs);
  }

  deleteOrg(org: Organization) {
    this.setOrgs(this.orgs.filter(o => o.ID !== org.ID));
  }

  getOrgs(): Organization[] {
    return this.orgs;
  }

  getRootOrgs(): Organization[] {
    return (this.orgs || []).filter(o => !o.ParentOrganizationID || !this.orgs.some(o2 => o2.ID === o.ParentOrganizationID));
  }

  hasRootAdminOrg(): boolean {
    if (this.rootOrgId && this.orgs[0].TypeCode != 'CS') {
      return true;
    } else {
      return false;
    }
  }
  setOrgs(organizations: Organization[]): void {
    this.orgs = organizations;
    const rootOrgs = this.getRootOrgs();
    if (rootOrgs.length === 1) {
      this.rootOrgId = rootOrgs[0].ID;
      localStorage.setItem('rootOrgId', '' + this.rootOrgId);
    }
    else {
      this.rootOrgId = null;
      localStorage.removeItem('rootOrgId');
    }

    localStorage.setItem('orgs', JSON.stringify(this.orgs));
    this.chameleonService.trySetChameleonIdentity();
  }
}
